import { Button } from "@repo/ui";
import { useEffect, useRef } from "react";

interface Props {
  value: string;
  onChange: (html: string) => void;
}

export default function RichTextEditor({ value, onChange }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== value) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  function handleInput() {
    onChange(ref.current?.innerHTML || "");
  }

  function cmd(command: string, value?: string) {
    document.execCommand(command, false, value);
    onChange(ref.current?.innerHTML || "");
  }

  return (
    <div className="grid gap-2">
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="outline" onClick={() => cmd("bold")}>
          B
        </Button>
        <Button type="button" variant="outline" onClick={() => cmd("italic")}>
          I
        </Button>
        <Button type="button" variant="outline" onClick={() => cmd("underline")}>
          U
        </Button>
        <Button type="button" variant="outline" onClick={() => cmd("insertUnorderedList")}>
          • List
        </Button>
        <Button type="button" variant="outline" onClick={() => cmd("insertOrderedList")}>
          1. List
        </Button>
        <Button type="button" variant="outline" onClick={() => cmd("formatBlock", "H2")}>
          H2
        </Button>
        <Button type="button" variant="outline" onClick={() => cmd("formatBlock", "H3")}>
          H3
        </Button>
        <Button type="button" variant="outline" onClick={() => cmd("removeFormat")}>
          Clear
        </Button>
      </div>
      <div
        ref={ref}
        onInput={handleInput}
        className="min-h-[240px] p-3 rounded-md border border-border bg-background focus:outline-none"
        contentEditable
        suppressContentEditableWarning
      />
    </div>
  );
}
